module.exports = __webpack_public_path__ + "img/esmeralda.240f8df9.png";